(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description Factory of Semafone PaymentService
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .factory('uteSemafonePaymentService', _factory);

  _factory.$inject = [];

  /* @ngInject */
  function _factory() {
    var _expireYears = [];
    var postExpireYearsNum = 10;
    var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    var ccTye = ['V', 'M', 'A']; //credit card types: visa, master and amex
    var service = {
      postExpireYearsNum: postExpireYearsNum,
      months: months,
      ccType: ccTye,
      expireYears: expireYears
    };

    return service;

    function expireYears() {
      //return already calculated data
      if (_expireYears.length > 0) {
        return _expireYears;
      }
      var _currentYear = new Date().getFullYear();
      _expireYears.push(_currentYear);
      //get current year and add up to 10 years
      for (var i = 1; i <= 10; i++) {
        _expireYears.push(_currentYear + i);
      }
      return _expireYears;
    }
  }

})();
